class CommonUtils {
  constructor () {
    this.regexForNumeric = /^[0-9]*$/;
    this.readablePhoneRegex = /(\d{3})(\d{3})(\d{2})(\d{2})/;
    // eslint-disable-next-line no-useless-escape
    this.emailRegex = /^[a-zA-Z0-9\._\-]{1,64}@(?:[a-zA-Z0-9\-]{1,63}\.){1,125}[a-zA-Z]{2,63}$/;
    this.phoneRegex = /^0?(\d{3})(\d{3})(\d{2})(\d{2})$/;
  }

  /**
   * Determine the given value is numeric
   * @param value
   * @returns {boolean}
   */
  isNumeric (value) {
    return this.regexForNumeric.test(value.toString());
  }

  /**
   * Make phone number readable
   * @param value
   * @param prefix
   * @returns {string}
   */
  makeReadablePhone (value, { prefix } = { prefix: '' }) {
    const phone = value.replace(this.readablePhoneRegex, '($1) $2 $3 $4');

    return `${prefix}${phone}`;
  }

  /**
   * Prune from non numeric characters
   * @param value
   * @returns {string}
   */
  makeNumberAsString (value) {
    return value.replace(/[^\d]/g, '');
  }

  /**
   * Make phone number readable
   * @param value
   * @returns {string}
   */
  formatPhone (value) {
    const phone = value.replace(this.phoneRegex, '$1$2$3$4');

    return `0${phone}`;
  }

  /**
   * Validate email
   * @param value
   * @return {boolean}
   */
  validateEmail (value) {
    return this.emailRegex.test(value);
  }

  /**
   * Validate phone number
   * @param value
   * @return {boolean}
   */
  validatePhone (value) {
    return this.phoneRegex.test(value);
  }
}

export default new CommonUtils();
